import React from 'react';

import * as Styled from './slider-bullets.styled';

type OwnProps = {
	className?: string;
	id?: string;
	isHidden?: boolean;
};

const SliderBullets: React.FC<OwnProps> = ({ className, id, isHidden = false }) => {
	return <Styled.SliderBulletsStyled id={'containerForBullets-' + id} className={className} $isHidden={isHidden} />;
};

export { SliderBullets };
